import { buildPriceChangeData1D } from "utils";
import log from "logbeacon";
import NextImage from "../NextImage";
import { DocsPriceChangeProps } from "./types";
import { Stock, StockMarketEnum, Token } from "@/src/features/api/openData";

export const DocsPriceChange = ({
  data,
  category,
  deviceType: serverDeviceType = "desktop",
}: DocsPriceChangeProps) => {
  const deviceType = serverDeviceType === "desktop" ? "desktop" : "mobile";
  return (
    <div
      className={`w-full  ${deviceType !== "mobile" ? "flex flex-row gap-2 mt-3" : "grid grid-cols-2 gap-2 max-w-[300px] mt-6"}`}
    >
      {data.slice(0, 4).map((item) => {
        let priceChangePercentage24h = 0;
        if (category === "crypto") {
          const token = item as Token;
          priceChangePercentage24h = Number(
            token?.market_data?.price_change_percentage?.find(
              (item) => item.time_period === "24h",
            )?.percentage,
          );
        } else {
          const stock = item as Stock;
          log.debug("[DocsPriceChange] stock === ", JSON.stringify(stock));
          priceChangePercentage24h = buildPriceChangeData1D({
            currentPrice: stock?.trading_data?.current_price || 0,
            closePrice: stock?.trading_data?.previous_close || 0,
          });
        }

        log.debug(
          "[DocsPriceChange] priceChangePercentage24h ",
          priceChangePercentage24h,
        );

        const priceChangeColor =
          priceChangePercentage24h >= 0
            ? "text-content_accent1_primary"
            : "text-content_accent2_primary";

        const isHKStock = (item: Token | Stock): item is Stock => {
          return "market" in item && item.market === StockMarketEnum.HK;
        };
        const itemName = isHKStock(item)
          ? item?.short_name || item?.symbol
          : item?.symbol;
        return (
          <a
            key={item.id}
            href={
              category === "crypto"
                ? `/crypto/${item.id}`
                : `/stock/${item.symbol}`
            }
            className={`${deviceType !== "mobile" ? "w-fit" : "w-full"} flex flex-row items-center gap-1 border-[1px] px-[6px] border-border_white_transparent10 rounded-[6px] py-[6px] overflow-hidden`}
          >
            <NextImage
              src={item.logo || ""}
              alt={item.name || ""}
              width={20}
              height={20}
              className="rounded-full"
            />
            <span className="text-content_primary body_medium_m">
              {itemName}
            </span>
            <span
              className={`text-content_primary body_medium_m ${priceChangeColor}`}
            >
              {`${priceChangePercentage24h > 0 ? "+" : ""}${priceChangePercentage24h.toFixed(2)}%`}
            </span>
          </a>
        );
      })}
    </div>
  );
};
